import React from 'react'
import find from 'lodash/find'
import { InvoiceStatusConstant as InvoiceStatusCommon } from '@ztechapps/totalmilk-payme.common'
import type { InvoiceStatusEnum } from '@ztechapps/totalmilk-payme.contract'

export const InvoiceStatus = ({
  status,
  statusColor,
}: {
  status: string | InvoiceStatusEnum
  statusColor?: string
}) => {
  const statusType = find(InvoiceStatusCommon, (e) => e.value === status)

  statusColor = statusColor || statusType.color

  return <div className={`fw-bold text-${statusColor}`}>{status}</div>
}
